import React from 'react';
import { Organization, OrganizationType } from '../../types/Organization';
interface OrganizationLinkProps {
    organization: Organization | null;
  }
const OrganizationLink: React.FC<OrganizationLinkProps>  = ({ organization }) => {
  if (!organization) return null;

  // Determine the correct link path based on the organization type
  const getOrganizationPath = (type: OrganizationType) => {
    switch (type) {
      case OrganizationType.Provider:
        return OrganizationType.Provider;
      case OrganizationType.Client:
        return OrganizationType.Client;
      case OrganizationType.Company:
        return OrganizationType.Company;
      default:
        return OrganizationType.Provider;
    }
  };

  return (
    <a
      href={`/${getOrganizationPath(organization.type)}/${organization.organizationId}`}
      target="_blank"
      rel="noopener noreferrer"
      title={`View ${organization.type} details`}
    >
      <i className="bi bi-box-arrow-up-right" /> 
    </a>
  );
};

export default OrganizationLink;
